<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <div slot="waitDeal" slot-scope="prop">
        <el-checkbox label="待我处理" name="type" v-model="prop.form.waitDeal" />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
  getDepartmentAllList,
} from 'api';
import {
  manageCostType,
} from 'api/cost';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        payTypeNameOptions: [], // 费用类型
        stateOptions: [], // 申请状态
        orgIdOptions: [], // 费用归属
        form: [
          { // 待我处理
            label: '待我处理',
            value: 'waitDeal',
            default: !this.$route.query.busiCode,
            slot: true,
          },
          { // 申请单号
            label: '申请单号',
            value: 'busiCode',
            type: 'input',
            placeholder: '请输入申请单号',
            default: this.$route.query.busiCode,
          },
          { // 申请时间
            label: '申请时间',
            value: 'Time',
            type: 'date',
            placeholder: '请选择申请时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 费用类型
            label: '费用类型',
            value: 'payTypeName',
            type: 'select',
            default: '0',
            placeholder: '请选择费用类型',
          },
          { // 申请状态
            label: '申请状态',
            value: 'state',
            type: 'select',
            default: '-1',
            placeholder: '请选择申请状态',
          },
          { // 费用归属
            label: '费用归属',
            value: 'orgId',
            type: 'select',
            default: '-1',
            placeholder: '请选择费用归属',
          },
          { // 申请人
            label: '申请人',
            value: 'applyUserName',
            type: 'input',
            placeholder: '请输入申请人',
          },
          { // 申请金额
            label: '申请金额',
            value: 'Amt',
            type: 'inputrange',
            placeholder: '请输入申请金额',
          },
          { // 收款方名称
            label: '收款方名称',
            value: 'receName',
            type: 'input',
            placeholder: '请输入收款方名称',
          },
          { // 收款账号
            label: '收款账号',
            value: 'receBankNo',
            type: 'input',
            placeholder: '请输入收款账号',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 申请时间
      if (searchBoxData.Time && searchBoxData.Time.length > 0) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
        delete searchBoxData.Time;
      }
      // 申请金额
      if (searchBoxData.Amt && searchBoxData.Amt.length > 0) {
        searchBoxData.startAmt = searchBoxData.Amt[0];
        searchBoxData.endAmt = searchBoxData.Amt[1];
        delete searchBoxData.Amt;
      }
      this.$refs.tableBox.saveSearchBoxData({
        '_GRID_TYPE': 'jq',

        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'PAYMANAGER_STATE',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...enumsList[0],
    ];
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...await getDepartmentAllList(),
    ];
    this.searchBoxData.payTypeNameOptions = [
      {
        label: '全部',
        value: '0',
      },
      ...await manageCostType(),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
